module.exports = __webpack_public_path__ + "static/media/Forward Icon_Yellow.a55e1a6f.svg";